/*
 * Issue #227: analytics events for modal open, send success and send failure, each carrying the
 * calculator, tab, entry context and brand.
 *
 * dataLayer is created by bare assignment in _Layout.cshtml (`dataLayer = [{...}]`), not with the usual
 * `window.dataLayer = window.dataLayer || []` guard, and the GTM snippet may not have run yet on a slow
 * connection. Every push here is therefore defensive; an analytics gap must never break the save.
 */

function push(payload) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    } catch (e) {
        /* Analytics is never allowed to break the feature. */
    }
}

function base(context) {
    return {
        calculator: context.calculatorSlug,
        calculatorName: context.calculatorDisplayName,
        tab: context.activeTab,
        entryContext: context.entryContext,
        brand: context.brand
    };
}

export function trackModalOpen(context) {
    push(Object.assign({ event: 'calculator_save_results_open' }, base(context)));
}

export function trackSendSuccess(context) {
    push(Object.assign({ event: 'calculator_save_results_success' }, base(context)));
}

export function trackSendFailure(context, reason) {
    push(Object.assign({ event: 'calculator_save_results_failure', failureReason: reason }, base(context)));
}

/*
 * AC-2's note: "attempts blocked by client-side validation never reach the server, so they cannot
 * create a database record -- they are captured as analytics events only." This is that event.
 */
export function trackClientValidationBlocked(context, fields) {
    push(Object.assign(
        { event: 'calculator_save_results_validation_blocked', invalidFields: fields.join(',') },
        base(context)));
}
